const SMSEncodings = {
  GSM_7BIT: 'GSM_7BIT',
  GSM_7BIT_EX: 'GSM_7BIT_EX',
  UTF16: 'UTF16',
};

const SMSEncodingLengthMap = {
  [SMSEncodings.GSM_7BIT]: 160,
  [SMSEncodings.GSM_7BIT_EX]: 160,
  [SMSEncodings.UTF16]: 70,
};
const SMSEncodingMultiMessageLengthMap = {
  [SMSEncodings.GSM_7BIT]: 153,
  [SMSEncodings.GSM_7BIT_EX]: 153,
  [SMSEncodings.UTF16]: 67,
};

export { SMSEncodings, SMSEncodingLengthMap, SMSEncodingMultiMessageLengthMap };
